 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"client-projects":"client-projects","concludeProjectIssue":"concludeProjectIssue","contactOrderStatistics~employeeIssueStatistics~invoices~projectIssueStatistics~projectOrderStatistic~c65cafba":"contactOrderStatistics~employeeIssueStatistics~invoices~projectIssueStatistics~projectOrderStatistic~c65cafba","contactOrderStatistics":"contactOrderStatistics","employeeIssueStatistics":"employeeIssueStatistics","projectIssueStatistics":"projectIssueStatistics","projectOrderStatistics":"projectOrderStatistics","projectPointStatistics":"projectPointStatistics","projectTimeSpentStatistics":"projectTimeSpentStatistics","contacts~createProject~editProject~invoices~orderStatisticsTabs~products~projectConfigurations~proje~a2d79a0b":"contacts~createProject~editProject~invoices~orderStatisticsTabs~products~projectConfigurations~proje~a2d79a0b","invoices":"invoices","receivedInvoices":"receivedInvoices","contacts":"contacts","createProject":"createProject","editProject":"editProject","orderStatisticsTabs":"orderStatisticsTabs","products":"products","projectConfigurations":"projectConfigurations","projectIssues":"projectIssues","projectStatistics":"projectStatistics","projectStatisticsTabs":"projectStatisticsTabs","projects":"projects","sentInvoices":"sentInvoices","supplierAgreements":"supplierAgreements","timeTracking":"timeTracking","users":"users","createContact":"createContact","createInvoice":"createInvoice","createProduct":"createProduct","createProjectIssue~editProjectIssue":"createProjectIssue~editProjectIssue","createProjectIssue":"createProjectIssue","editProjectIssue":"editProjectIssue","createProjectSprint":"createProjectSprint","createProjectUserStoryBulk":"createProjectUserStoryBulk","createProjectUserStory~createProjectUserStoryFromIssue~editProjectUserStory":"createProjectUserStory~createProjectUserStoryFromIssue~editProjectUserStory","createProjectUserStory":"createProjectUserStory","createProjectUserStoryFromIssue":"createProjectUserStoryFromIssue","editProjectUserStory":"editProjectUserStory","createShortcut":"createShortcut","createUser":"createUser","editContact":"editContact","editInvoice":"editInvoice","editProduct":"editProduct","editProjectSprint":"editProjectSprint","editReceivedInvoice":"editReceivedInvoice","editSentInvoice":"editSentInvoice","editShortcut":"editShortcut","editSupplierAgreement":"editSupplierAgreement","editUser":"editUser","editUserPermissions":"editUserPermissions","invoice":"invoice","issueCreatedByStatistics":"issueCreatedByStatistics","moveSelectedUserStories":"moveSelectedUserStories","profile":"profile","project":"project","projectSettings":"projectSettings","projectSprintUserStoriesSummary":"projectSprintUserStoriesSummary","projectTeam":"projectTeam","sendInvoice":"sendInvoice"}[chunkId]||chunkId) + "." + {"client-projects":"3b1f60e8","concludeProjectIssue":"7ee9e40b","contactOrderStatistics~employeeIssueStatistics~invoices~projectIssueStatistics~projectOrderStatistic~c65cafba":"b02d3261","contactOrderStatistics":"749b3130","employeeIssueStatistics":"23afae40","projectIssueStatistics":"9c2c2a47","projectOrderStatistics":"41a4fb5e","projectPointStatistics":"64adb27b","projectTimeSpentStatistics":"1628791c","contacts~createProject~editProject~invoices~orderStatisticsTabs~products~projectConfigurations~proje~a2d79a0b":"ffb85f28","invoices":"fc7489a0","receivedInvoices":"fddbe72e","contacts":"1ae56496","createProject":"b726af2a","editProject":"598c0d88","orderStatisticsTabs":"4ca7fec2","products":"3e843329","projectConfigurations":"88a4356f","projectIssues":"885b6cbc","projectStatistics":"8c9c1c05","projectStatisticsTabs":"1a1116a5","projects":"598ea111","sentInvoices":"5cc948f7","supplierAgreements":"90913acf","timeTracking":"c78aa311","users":"f49e4e80","createContact":"82f7c68f","createInvoice":"d194234a","createProduct":"055eb278","createProjectIssue~editProjectIssue":"1278fa00","createProjectIssue":"17ed37d4","editProjectIssue":"c70fe60a","createProjectSprint":"64d1ff26","createProjectUserStoryBulk":"651083b2","createProjectUserStory~createProjectUserStoryFromIssue~editProjectUserStory":"f60ffb08","createProjectUserStory":"5bb3f552","createProjectUserStoryFromIssue":"cf0f5eff","editProjectUserStory":"d6c3cdd3","createShortcut":"3c6b1432","createUser":"4ca16203","editContact":"18e33dd4","editInvoice":"2e318d80","editProduct":"37e01f30","editProjectSprint":"26f622c8","editReceivedInvoice":"2d23a362","editSentInvoice":"d043d13f","editShortcut":"69d004a4","editSupplierAgreement":"cd580a98","editUser":"bdbeb6be","editUserPermissions":"b9e65969","invoice":"0147529f","issueCreatedByStatistics":"fde32098","moveSelectedUserStories":"540b9d0b","profile":"1a962f24","project":"fa467213","projectSettings":"467f24e4","projectSprintUserStoriesSummary":"18425a7c","projectTeam":"7ce2515e","sendInvoice":"3a52fad8"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"projectPointStatistics":1,"contacts~createProject~editProject~invoices~orderStatisticsTabs~products~projectConfigurations~proje~a2d79a0b":1,"invoices":1,"receivedInvoices":1,"projectConfigurations":1,"timeTracking":1,"createProjectUserStory~createProjectUserStoryFromIssue~editProjectUserStory":1,"editContact":1,"editUserPermissions":1,"invoice":1,"project":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"client-projects":"client-projects","concludeProjectIssue":"concludeProjectIssue","contactOrderStatistics~employeeIssueStatistics~invoices~projectIssueStatistics~projectOrderStatistic~c65cafba":"contactOrderStatistics~employeeIssueStatistics~invoices~projectIssueStatistics~projectOrderStatistic~c65cafba","contactOrderStatistics":"contactOrderStatistics","employeeIssueStatistics":"employeeIssueStatistics","projectIssueStatistics":"projectIssueStatistics","projectOrderStatistics":"projectOrderStatistics","projectPointStatistics":"projectPointStatistics","projectTimeSpentStatistics":"projectTimeSpentStatistics","contacts~createProject~editProject~invoices~orderStatisticsTabs~products~projectConfigurations~proje~a2d79a0b":"contacts~createProject~editProject~invoices~orderStatisticsTabs~products~projectConfigurations~proje~a2d79a0b","invoices":"invoices","receivedInvoices":"receivedInvoices","contacts":"contacts","createProject":"createProject","editProject":"editProject","orderStatisticsTabs":"orderStatisticsTabs","products":"products","projectConfigurations":"projectConfigurations","projectIssues":"projectIssues","projectStatistics":"projectStatistics","projectStatisticsTabs":"projectStatisticsTabs","projects":"projects","sentInvoices":"sentInvoices","supplierAgreements":"supplierAgreements","timeTracking":"timeTracking","users":"users","createContact":"createContact","createInvoice":"createInvoice","createProduct":"createProduct","createProjectIssue~editProjectIssue":"createProjectIssue~editProjectIssue","createProjectIssue":"createProjectIssue","editProjectIssue":"editProjectIssue","createProjectSprint":"createProjectSprint","createProjectUserStoryBulk":"createProjectUserStoryBulk","createProjectUserStory~createProjectUserStoryFromIssue~editProjectUserStory":"createProjectUserStory~createProjectUserStoryFromIssue~editProjectUserStory","createProjectUserStory":"createProjectUserStory","createProjectUserStoryFromIssue":"createProjectUserStoryFromIssue","editProjectUserStory":"editProjectUserStory","createShortcut":"createShortcut","createUser":"createUser","editContact":"editContact","editInvoice":"editInvoice","editProduct":"editProduct","editProjectSprint":"editProjectSprint","editReceivedInvoice":"editReceivedInvoice","editSentInvoice":"editSentInvoice","editShortcut":"editShortcut","editSupplierAgreement":"editSupplierAgreement","editUser":"editUser","editUserPermissions":"editUserPermissions","invoice":"invoice","issueCreatedByStatistics":"issueCreatedByStatistics","moveSelectedUserStories":"moveSelectedUserStories","profile":"profile","project":"project","projectSettings":"projectSettings","projectSprintUserStoriesSummary":"projectSprintUserStoriesSummary","projectTeam":"projectTeam","sendInvoice":"sendInvoice"}[chunkId]||chunkId) + "." + {"client-projects":"31d6cfe0","concludeProjectIssue":"31d6cfe0","contactOrderStatistics~employeeIssueStatistics~invoices~projectIssueStatistics~projectOrderStatistic~c65cafba":"31d6cfe0","contactOrderStatistics":"31d6cfe0","employeeIssueStatistics":"31d6cfe0","projectIssueStatistics":"31d6cfe0","projectOrderStatistics":"31d6cfe0","projectPointStatistics":"c40add57","projectTimeSpentStatistics":"31d6cfe0","contacts~createProject~editProject~invoices~orderStatisticsTabs~products~projectConfigurations~proje~a2d79a0b":"7df717b5","invoices":"395c3698","receivedInvoices":"395c3698","contacts":"31d6cfe0","createProject":"31d6cfe0","editProject":"31d6cfe0","orderStatisticsTabs":"31d6cfe0","products":"31d6cfe0","projectConfigurations":"7a1a00b6","projectIssues":"31d6cfe0","projectStatistics":"31d6cfe0","projectStatisticsTabs":"31d6cfe0","projects":"31d6cfe0","sentInvoices":"31d6cfe0","supplierAgreements":"31d6cfe0","timeTracking":"0ea70784","users":"31d6cfe0","createContact":"31d6cfe0","createInvoice":"31d6cfe0","createProduct":"31d6cfe0","createProjectIssue~editProjectIssue":"31d6cfe0","createProjectIssue":"31d6cfe0","editProjectIssue":"31d6cfe0","createProjectSprint":"31d6cfe0","createProjectUserStoryBulk":"31d6cfe0","createProjectUserStory~createProjectUserStoryFromIssue~editProjectUserStory":"50f7e260","createProjectUserStory":"31d6cfe0","createProjectUserStoryFromIssue":"31d6cfe0","editProjectUserStory":"31d6cfe0","createShortcut":"31d6cfe0","createUser":"31d6cfe0","editContact":"b67733e0","editInvoice":"31d6cfe0","editProduct":"31d6cfe0","editProjectSprint":"31d6cfe0","editReceivedInvoice":"31d6cfe0","editSentInvoice":"31d6cfe0","editShortcut":"31d6cfe0","editSupplierAgreement":"31d6cfe0","editUser":"31d6cfe0","editUserPermissions":"b67733e0","invoice":"a115a2e1","issueCreatedByStatistics":"31d6cfe0","moveSelectedUserStories":"31d6cfe0","profile":"31d6cfe0","project":"6d885c5e","projectSettings":"31d6cfe0","projectSprintUserStoriesSummary":"31d6cfe0","projectTeam":"31d6cfe0","sendInvoice":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
